module.exports = __webpack_public_path__ + "media/images/games/35gender/rap-a55d09104749c2e94a7e9a43d35ae015.png";